import { AbsencesCalendarHeaderMonthItem } from "./absences-calendar-header-month-item";
import { AbsencesCalendarHeaderQuarterItem } from "./absences-calendar-header-quarter-item";
import { AbsencesCalendarHeaderWeekItem } from "./absences-calendar-header-week-item";
import { AbsencesCalendarHeaderYearItem } from "./absences-calendar-header-year-item";
import { AbsencesCalendarRowWrapper } from "./absences-calendar-row-wrapper";
import { useAbsencesCalendarContext } from "./context";

export function AbsencesCalendarHeader() {
	/** Context */
	const { controller } = useAbsencesCalendarContext();
	const { cells, mode, getCurrentString, constants } = controller;
	const currentString = getCurrentString();

	/** Render */
	return (
		<AbsencesCalendarRowWrapper variant="header">
			<div className="w-full h-full p-0! relative">
				<div
					className="h-stack justify-between h-full px-3"
					style={{
						width: constants.FIRST_COLUMN_WIDTH,
					}}
				>
					<p className="font-semibold">{currentString}</p>
				</div>
			</div>
			{cells.map((cell, index) => (
				<div
					className="w-full h-full **:text-xs! relative p-0!"
					key={index}
				>
					{mode === "week" && <AbsencesCalendarHeaderWeekItem cell={cell} />}
					{mode === "month" && <AbsencesCalendarHeaderMonthItem cell={cell} />}
					{mode === "quarter" && <AbsencesCalendarHeaderQuarterItem cell={cell} />}
					{mode === "year" && <AbsencesCalendarHeaderYearItem cell={cell} />}
				</div>
			))}
		</AbsencesCalendarRowWrapper>
	);
}
